import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 'var(--space-6)', background: 'var(--bg-canvas)' }}>
      <div style={{ width: '100%', maxWidth: 420, background: 'var(--bg-surface)',
        border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-6)',
        textAlign: 'center', boxShadow: 'var(--shadow-md)' }}>
        <div style={{ fontSize: 64, fontWeight: 800, lineHeight: 1.1, color: 'var(--color-primary)',
          fontFamily: 'var(--font-mono)', marginBottom: 'var(--space-2)' }}>404</div>
        <h1 style={{ fontSize: 'var(--text-lg)', fontWeight: 600, color: 'var(--text-primary)', marginBottom: 'var(--space-2)' }}>
          Page not found
        </h1>
        <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-tertiary)', marginBottom: 'var(--space-4)' }}>
          The page you're looking for moved, or never existed.
        </p>
        <Link to="/" className="btn btn--primary" style={{ textDecoration: 'none' }}>Back to dashboard</Link>
      </div>
    </div>
  )
}
